<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">
        {{ $t('common.indexPage') }}
      </router-link>
      <span class="slash">/</span>
      <router-link
        :to="{
          name: 'IndexRecommendGoods',
          query: {
            title: $route.query.title,
            recommend: $route.query.recommend,
          },
        }"
      >
        {{ $route.query.title }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">{{ goods.name }}</span>
    </div>
    <div class="bread" v-else>
      <router-link :to="{ name: 'Ebooks' }">电子书</router-link>
      <span class="slash">/</span>
      <span class="current">{{ goods.name }}</span>
    </div>
    <template>
      <div class="detail">
        <img class="cover" :src="goods.cover_img" />
        <div class="right">
          <div class="title">{{ goods.name }}</div>
          <div class="brief author">作者：{{ goods.author }}</div>
          <div class="brief">
            {{ goods.classify && goods.classify.title }}
          </div>
          <div class="coupon-box" :class="couponList.length == 0 ? 'empty-coupon' : ''">
            <span v-if="showCoupon">优惠券：</span>
            <Coupon
              v-if="showCoupon"
              class="coupons"
              @getCoupon="getCoupon"
              :couponList="couponList"
              :defaultCount="6"
            ></Coupon>
          </div>
          <!-- 价格 -->
          <div class="price-box">
            <span class="price">
              <CurrencyNew
                v-if="goods.price"
                :price="goods.price"
                :priceUnderline="goods.underlined_price"
                :priceTwo="true"
                :isUnderlineLeft="false"
              ></CurrencyNew>
              <span v-else>{{ $t('common.free') }}</span>
            </span>
          </div>
          <div class="spell" v-if="goods.spell_price > 0">
            <div class="btn-buy btn-buy-spell">
              <div class="price">
                <Currency></Currency>
                <span v-if="goods.head_price">
                  {{ goods.head_price / 100 }}
                </span>
                <span v-else>{{ goods.spell_price / 100 }}</span>
              </div>
              <div class="label">{{ $t('goods.beginGroup') }}</div>
              <div class="spell-qr">
                <div class="header">{{ $t('goods.scanGroup') }}</div>
                <vue-qr :text="shareUrl" :size="200" class="qrcode"></vue-qr>
              </div>
            </div>
            <div class="btn-buy" @click="goToBuy">
              <div class="price">
                <Currency></Currency>
                <span>{{ goods.price / 100 }}</span>
              </div>
              <div class="label">{{ $t('goods.buyDirect') }}</div>
            </div>
            <div style="clear: both"></div>
          </div>
          <div v-else class="btn-box">
            <div class="btn-buy" @click="goToBuy">
              {{ goods.is_buy ? '立即阅读' : $t('goods.buyNow') }}
            </div>
            <div class="sales-num-wrap">
              <span class="buy-num">
                {{ goods.sales_num + (goods.sales_base || 0) }}{{ $t('goods.totalBuy') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="tab">
          <span class="tab-title">电子书介绍</span>
        </div>
        <div v-html="goods.introduction"></div>
      </div>
    </template>
    <CourseSoldOut
      v-if="goods.status == 2 || goods.status == 3"
      router-name="Book"
      :name="$t('goods.goods')"
    ></CourseSoldOut>
  </div>
</template>
<script>
import VueQr from 'vue-qr';
import Coupon from '../../components/Coupon.vue';
import CourseSoldOut from '../../components/CourseSoldOut.vue';
export default {
  name: 'EbooksDetail',
  components: {
    VueQr,
    Coupon,
    CourseSoldOut,
  },
  data() {
    return {
      id: this.$route.params.id,
      goods: {},
      couponList: [],
      showShareModal: false,
    };
  },
  computed: {
    shareUrl() {
      return this.$store.state.commonSetting.h5_address + '/goods_detail?id=' + this.id;
    },
    showCoupon() {
      return this.goods.couponList && this.goods.couponList.length > 0 && !this.goods.is_buy;
    },
  },
  async created() {
    await this.getData();
    // await this.incrementBrosweNum();
  },
  methods: {
    async incrementBrosweNum() {
      await this.$http.put('/api/app/goods/pv/' + this.id);
      this.goods.browse_num++;
    },
    async getData() {
      let data = await this.$http.get('/api/app/ebook/' + this.id);
      this.goods = data;
      this.couponList = data.couponList;
      // this.recommends = await this.$http.get(
      //   "/api/app/goods/recommend/" + this.id,
      // );
    },
    goToBuy() {
      if (1 > this.goods.stock - this.goods.sales_num) {
        this.$info(this.$t('common.stockEmpty'));
        return;
      }
      if (this.goods.is_buy) {
        // this.$router.push({
        //   name: "MemberEbooks",
        // });
        this.$router.push(`/ebooks/reader/${this.goods.id}`);
        return;
      }
      let obj = {
        shop_id: this.goods.id,
        shop_type: 22,
        coupon_id: 0,
        product_number: 1,
      };
      this.$router.push({
        name: 'OrderConfirm',
        params: { id: this.id },
        query: {
          type: 22,
          num: 1,
          order_type: 1,
          shop_infos: JSON.stringify([obj]),
        },
      });
    },
    async getCoupon(id) {
      let data = await this.$http.get('/api/app/userGetCoupon/' + id);
      this.couponList.filter((c) => c.id == id)[0].is_can_get = data.is_continue_get == 1 ? 1 : 0;
      this.$message({
        message: this.$t('common.couponSuccess'),
        type: 'success',
      });
    },
  },
  watch: {
    async $route() {
      this.id = this.$route.params.id;
      await this.getData();
      // await this.incrementBrosweNum();
    },
  },
};
</script>
<style lang="scss" scoped>
.detail {
  background-color: white;
  border-radius: 6px;
  padding: 24px;
  padding-left: 0;
  position: relative;
  display: flex;
  .coupon-empty {
    height: 24px;
  }
  .right {
    flex-grow: 1;
  }

  .cover {
    width: 180px;
    height: 260px;
    margin-right: 24px;
    margin-left: 30px;
    border-radius: 10px;
  }

  .title {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(32, 36, 42, 1);
    line-height: 36px;
    letter-spacing: 1px;
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .brief {
    font-size: 14px;
    color: #999999;
    // margin-bottom: 8px;
    height: 42px;
    // border: 1px solid red;
    &.author {
      margin-bottom: 8px;
      height: 24px;
    }
  }
  .instruction {
    margin-bottom: 10px;
    color: #b7b7b7;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .author-wrap {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #8c8c8c;
    line-height: 20px;
    letter-spacing: 1px;
    margin-bottom: 15px;

    .author {
      font-weight: 500;
      color: rgba(32, 36, 42, 1);
    }

    .line {
      margin: 0 22px;
    }

    .buy-num {
      margin-right: 50px;
    }
  }

  .price-box {
    display: flex;
    align-items: center;
    font-size: 26px;
    color: rgba(238, 31, 31, 1);
    margin: 10px 0;
    .price {
      display: flex;
      align-items: center;
      margin-right: 10px;

      span {
        font-family: PingFang SC, PingFang SC-Regular;
        line-height: 32px;
        height: 32px;

        // display: inline-block;
        ::v-deep .price {
          margin-right: 8px;
          font-weight: 600;
          font-size: 20px;
        }

        ::v-deep .decimal {
          font-size: 13px;
        }
      }

      img {
        height: 24px;
      }

      span,
      img {
        vertical-align: middle;
      }
    }

    .ship-price {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: rgba(140, 140, 140, 1);

      span {
        height: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 20px;
        display: inline-block;
      }

      img {
        height: 14px;
      }

      span,
      img {
        vertical-align: middle;
      }
    }
  }
  .coupon-box {
    background: #fafafa;
    border-radius: 6px;
    display: flex;
    align-items: center;
    // margin-top: 10px;
    padding: 0 10px;
    height: 54px;
    &.empty-coupon {
      background: #ffffff;
    }
    & > span {
      font-size: 14px;
      color: #999999;
    }
  }
  .coupons {
    min-height: 54px;
    // margin: 16px 0 15px 0;
    position: relative;
    bottom: 0;
    flex-grow: 1;
    flex: 1;
    ::v-deep .coupon {
      margin: 0 10px 0 0;
    }
  }

  .buy-num-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 25px;

    img {
      cursor: pointer;
    }

    .num {
      display: inline-block;
      box-sizing: border-box;
      width: 95px;
      height: 34px;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      border: 1px solid rgba(91, 96, 102, 1);
      text-align: center;
      line-height: 32px;
      margin: 0 10px;
    }

    .stock {
      background: rgba(244, 244, 244, 1);
      border-radius: 17px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(140, 140, 140, 1);
      line-height: 20px;
      padding: 7px 20px;
      margin-left: 20px;
    }
  }

  .spell {
    .btn-buy {
      width: 108px;
      height: 39px;
      background: rgba(231, 77, 61, 0.2);
      border-radius: 23px;
      float: left;
      margin-right: 15px;
      box-sizing: border-box;
      padding: 5px;
      color: rgba(231, 77, 61, 1);
      position: relative;

      &:hover {
        background: rgba(231, 77, 61, 1);
        color: white;

        .spell-qr {
          display: block;
        }
      }

      .price {
        height: 14x;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          height: 12px;
          margin-right: 3px;
        }
      }

      .label {
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 18px;
      }
    }

    .spell-qr {
      position: absolute;
      width: 152px;
      z-index: 999;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px 7px 7px 7px;
      background-color: white;
      left: 0;
      top: 60px;
      display: none;

      .qrcode {
        line-height: 1;
      }

      .header {
        background: rgba(217, 217, 217, 1);
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(140, 140, 140, 1);
        line-height: 20px;
        padding: 16px 0 10px 0;
        border-radius: 10px 7px 0 0;
        display: block;
      }

      &::before {
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        border: solid 8px transparent;
        border-bottom-color: rgba(217, 217, 217, 1);
        top: -16px;
        left: 34px;
      }
    }
  }
  .btn-box {
    display: flex;
    align-items: center;
    .btn-buy {
      width: 116px;
      height: 40px;
      background: $primary-color;
      border-radius: 21px 21px 21px 21px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
    .sales-num-wrap {
      font-size: 13px;
      color: #999999;
      margin-left: 48px;
    }
  }

  .el-tabs-custom .el-tabs__nav-wrap::after {
    background-color: #e6e6e6;
  }

  .spell-qr {
    img {
      max-width: 100%;
      border-radius: 0 0 7px 7px;
      vertical-align: bottom;
    }
  }
}
.main {
  margin-top: 16px;
  background: #ffffff;
  padding: 24px;
  margin-bottom: 38px;
  .tab {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;
    width: 90px;
    margin-bottom: 24px;
    .tab-title {
      width: 90px;
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 7px !important;
        background: linear-gradient(90deg, $primary-color-8, $primary-color) !important;
        opacity: 0.8;
        left: -2px;
        bottom: -2px;
        padding: 0 2px;
      }
    }
  }
}
</style>
